<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import {
		mapMutations,
		mapActions
	} from 'vuex'

	export default {
		
		created() {
			if(localStorage.getItem('nextToken')!='null'){
				this.setToken(localStorage.getItem('nextToken'))
			}
			const schoolData = JSON.parse(localStorage.getItem('schoolData'));
			const userInfo = JSON.parse(localStorage.getItem('userInfo'));

			if (schoolData) {
				this.setSchoolData(schoolData)
			}
			if (userInfo) {
				this.setUserInfo(userInfo)
			}

			if (localStorage.getItem('defaultimg')) {
				this.defaultimg(localStorage.getItem('defaultimg'))
			}
			if (localStorage.getItem('admin_id')) {
				this.getUserInfo()
				
				this.$util.post(
					"job/im/updateUserStatus", {
						userId:localStorage.getItem('admin_id'),
						platform:3,
						userType:1,
						onlineStatus:1,
					},
					(res) => {
						
					}
				);
			}

			if (localStorage.getItem('user_id')) {
				this.getCompanyUserInfo()
			}
			
			window.addEventListener('unload', () => {
				console.log(123)
				    // 页面隐藏 = 即将关闭/刷新/切走 → 立即上报离线
					  const userId = localStorage.getItem('admin_id')
					  const formData = new FormData()
					    formData.append('userId', userId)
					    formData.append('platform', 3)
					    formData.append('userType', 1)
					    formData.append('onlineStatus', 0)
					  
					  navigator.sendBeacon('https://np.sx985.com/job/im/updateUserStatus', formData)
					  
					  
					//   xhr.open('POST','https://np.sx985.com/job/im/updateUserStatus', false);
					//   xhr.withCredentials = true;
					
					//   xhr.send(formData);
					// xhr.onreadystatechange = function() {
					// 	localStorage.setItem('xhr',xhr)
					// 	console.log(xhr)
					// }
			})
			
			
			 // 监听网络事件
			    window.addEventListener('online', this.handleOnline)
			    window.addEventListener('offline', this.handleOffline)
		},
		 beforeDestroy() {
		    // 销毁：必须移除监听，防止内存泄漏
		    window.removeEventListener('online',this.handleOnline)
		    window.removeEventListener('offline',this.handleOffline)
		  },
		
		methods: {
			...mapMutations(['setIslogin', 'setToken', 'setUserInfo', 'setSchoolData', 'defaultimg']),
			...mapActions(['getUserInfo', 'getCompanyUserInfo']),
			 // 网络恢复
			    handleOnline() {
			      this.$message.success('网络已恢复')
				  location.reload(true)
			      // 可选：重新请求接口
			      // this.getcatalogall()
			    },
			    // 网络断开
			    handleOffline() {
			      this.$message.error('网络已断开，请检查网络连接')
				  location.reload(true)
			    },
		}
	}
</script>
<style>
	#meeting .tableContainer .header-row-class-name .el-checkbox__inner{
		border: 2px solid #409EFF !important;
	}
	/* .el-textarea__inner::placeholder {
		color: #000000;
	}

	.el-textarea__inner {
		color: #000000;
	}

	.el-input__inner::placeholder {
		color: #000000;
	} */
	.el-table .cell{
		line-height: initial !important;
	}
	.pagingLeft .el-button:hover{
		color: #1E40AF !important;
		border: 1px solid #1E40AF !important;
	}
	.pagingLeft .delete .el-button:hover{
		color: #fff !important;
		border: 1px solid #F56C6C !important;
	}
	/* .el-pagination.is-background .el-pager li:hover {
		color: #1E40AF !important;
	} */
	
	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background: #1E40AF !important;
	}

	.el-upload-list--picture-card .el-upload-list__item {
		width: 120px !important;
		height: 120px !important;
	}

	.el-upload--picture-card {
		width: 120px !important;
		height: 120px !important;
		/* line-height: 120px !important; */
	}

	.el-dialog__title {
		font-size: 16px !important;
		font-weight: bold !important;
		color: #000;
	}

	.el-textarea__inner {
		min-height: 150px !important;
		font-size: 14px !important;
		padding: 15px 15px !important;
		font-family: initial !important;
	}

	.el-button {
		padding: 8px 15px !important;
		font-size: 14px !important;
	}

	.el-button--primary {
		color: #FFF;
		background-color: #1E40AF !important;
		border-color: #1E40AF !important;
	}

	.el-table__header th {
		font-weight: 500 !important;
		color: #333 !important;
	}

	.el-table__body td {
		font-weight: 500 !important;
		color: #333 !important;
	}

	/* .el-input__inner {
		min-height: 35px !important;
		line-height: 35px !important;
	} */

	.el-input__icon {
		line-height: 35px !important;
	}

	.el-radio-button__inner {
		padding: 8px 20px !important;
	}

	.el-input__icon {
		line-height: 35px;
	}

	.el-dialog {
		border-radius: 10px !important;
		margin-top: 5vh !important;
		/* margin: 0 !important;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%); */
	}

	/* .el-select__tags{
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	} */
</style>
<style lang="less">
	@font-face {
		font-family: abc;
		src: url(./assets/PingFang.ttf);
	}

	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		font-family: abc;
	}

	.flex-h,
	.flex-v {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.flex-h {
		flex-direction: row;
	}

	.flex-v {
		flex-direction: column;
	}

	.flex1 {
		flex: 1;
		overflow: hidden;
	}

	li {
		list-style: none;
	}

	a {
		color: #000;
		text-decoration: none;
	}

	.one-line {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.two-line {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2; //两行，根据需求可更改
		overflow: hidden;
	}

	.company_avatar {
		margin-right: 10px;

		img {
			width: 57px;
			height: 57px;
			border-radius: 50%;
		}

		.company_name {
			width: 57px;
			height: 57px;
			border-radius: 50%;

			text-align: center;
			line-height: 57px;

			font-size: 18px;
			border: 1rpx solid #FFFFFF;
			color: #fff;
			background-color: #FF6600;
		}
	}

	.onlytitleClass {
		width: 100%;
		padding: 20px 0 20px 0;
		// border-bottom: 1px solid #EEEEEE;
		display: flex;
		align-items: center;
		// margin-bottom: 25px;

		.title {
			margin-right: 20px;
			font-weight: 500;
			font-size: 16px;
			color: #2D3C50;
		}

		.stateContainer {
			margin-bottom: 30px;
		}
	}
</style>